const reducedMotionQuery = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
);
const BUBBLE_VISIBLE_DURATION = 5000;

const setBubbleVisibility = (bubble, isVisible, immediately = false) => {
  bubble.style.transformBox = "fill-box";
  bubble.style.transformOrigin = "center bottom";
  bubble.style.transition = immediately
    ? "none"
    : "opacity 520ms ease-out, transform 760ms cubic-bezier(0.22, 1.35, 0.36, 1)";
  bubble.style.opacity = isVisible ? "1" : "0";
  bubble.style.transform = isVisible
    ? "translateY(0) scale(1)"
    : "translateY(10px) scale(0.82)";
};

const hideBubble = (bubble, immediately = false) => {
  bubble.style.transition = immediately ? "none" : "opacity 520ms ease-in";
  bubble.style.opacity = "0";
};

const scheduleBubbleHide = (bubble) => {
  window.setTimeout(() => {
    hideBubble(bubble, reducedMotionQuery.matches);
  }, BUBBLE_VISIBLE_DURATION);
};

export const initServiceIllustrations = () => {
  const illustrations = document.querySelectorAll(".js-service-illustration");

  for (const illustration of illustrations) {
    const illustrationObject = illustration.querySelector(
      ".js-service-illustration-object",
    );

    if (!illustrationObject) {
      continue;
    }

    let bubbles = [];
    let isReady = false;
    let hasEntered = false;
    let hasRevealed = false;

    const loadIllustration = () => {
      if (
        !illustrationObject.data &&
        illustrationObject.dataset.illustrationSrc
      ) {
        illustrationObject.data = illustrationObject.dataset.illustrationSrc;
      }
    };

    const revealBubbles = () => {
      if (!isReady || !hasEntered || hasRevealed) {
        return;
      }

      hasRevealed = true;

      if (reducedMotionQuery.matches) {
        for (const bubble of bubbles) {
          setBubbleVisibility(bubble, true, true);
          scheduleBubbleHide(bubble);
        }
        return;
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          bubbles.forEach((bubble, index) => {
            window.setTimeout(() => {
              setBubbleVisibility(bubble, true);
              scheduleBubbleHide(bubble);
            }, index * 90);
          });
        });
      });
    };

    illustrationObject.addEventListener("load", () => {
      const illustrationDocument = illustrationObject.contentDocument;

      if (illustrationDocument) {
        bubbles = Array.from(
          illustrationDocument.querySelectorAll('[id^="fukidashi"]'),
        );

        for (const bubble of bubbles) {
          setBubbleVisibility(bubble, false, true);
        }
      }

      isReady = true;
      illustrationObject.classList.add("is-ready");
      revealBubbles();
    });

    if (!("IntersectionObserver" in window)) {
      hasEntered = true;
      loadIllustration();
      continue;
    }

    const loadObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) {
          return;
        }

        loadIllustration();
        loadObserver.disconnect();
      },
      { rootMargin: "500px 0px" },
    );

    const revealObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          return;
        }

        hasEntered = true;
        loadIllustration();
        revealBubbles();
        revealObserver.disconnect();
      },
      { threshold: 0.2 },
    );

    loadObserver.observe(illustration);
    revealObserver.observe(illustration);
  }
};
